/* eslint-disable max-classes-per-file */
// Utils
import { Auth, getCookie, setCookie } from "../lib/cookie";

// Clients
import { AdminClient } from './BackendAdminClient/admin'
import { MicrosoftClient } from './BackendAdminClient/microsoft';
import { MorningCoin } from './BackendAdminClient/morning-coin'
import { ProjectJuristicFeature } from './BackendAdminClient/project-juristic-feature'
import { Provider } from './BackendAdminClient/provider'
import { Receipt } from './BackendAdminClient/receipt'
import { Report } from './BackendAdminClient/report'
import { ServiceCategory } from "./BackendAdminClient/service-categories";
import { Subscriber } from './BackendAdminClient/subscriber'
import { Subscriptions } from './BackendAdminClient/subscriptions'
import { User } from './BackendAdminClient/user'
import { VirtualSport } from './BackendAdminClient/virtual-sport';

export class AuthClient {
  constructor(apiUrl) {
    const authUrl = `${apiUrl}/auth`;

    this.microsoft = new MicrosoftClient(authUrl);
  }
}

export class BackendAdminClient {
  // eslint-disable-next-line class-methods-use-this
  get token() {
    return getCookie(Auth.AccessToken);
  }

  // eslint-disable-next-line class-methods-use-this
  set token(accessToken) {
    setCookie(Auth.AccessToken, accessToken);
  }

  get headers() {
    return { Authorization: `Bearer ${this.token}` };
  }

  // eslint-disable-next-line class-methods-use-this
  get backendUrl() {
    return `${process.env.ADMIN_HOST}/ruejai-backend-admin`;
  }

  setToken(accessToken) {
    if (accessToken) {
      this.token = accessToken;

      this.updateHeaders();
    }
  }

  updateHeaders() {
    this.admin.setHeaders(this.headers);
  }

  constructor() {
    const apiUrl = `${this.backendUrl}/api`;

    this.admin = new AdminClient(apiUrl, this.headers);
    this.auth = new AuthClient(apiUrl);
    this.morningCoin = new MorningCoin(apiUrl, this.headers);
    this.subscriptions = new Subscriptions(apiUrl, this.headers);
    this.user = new User(apiUrl, this.headers);
    this.provider = new Provider(apiUrl, this.headers);
    this.receipt = new Receipt(apiUrl, this.headers);
    this.report = new Report(apiUrl, this.headers);
    this.subscriber = new Subscriber(apiUrl, this.headers);
    this.projectJuristic = new ProjectJuristicFeature(apiUrl, this.headers);
    this.serviceCategory = new ServiceCategory(apiUrl, this.headers);
    this.virtualSport = new VirtualSport(apiUrl, this.headers);
  }
}
